export const NON_MARKETING_TEAMS = [
    'AE-Fresh',
    'AE-QC',
    'AHS',
    'AFS',
    'AGL-FixedCosts-DE',
    'AGL-FixedCosts-IT',
    'AGL-FixedCosts-SP',
    'AGL-FixedCosts-UK',
    'AGL',
    'Amazon-Publishing-Vendor-Management',
    'AMXL-EGY',
    'AMXL-EU-Recycling',
    'AMXL-KSA',
    'AMXL',
    'AMZL-EGY',
    'AMZL-KSA',
    'Air',
    'Amazon-Music',
    'AmazonStudiosLocalization',
    'AMOC-ATS-BBM',
    'AMOC-ATS-Janitorial',
    'AMOC-FR-Regulatory-Control-Provide',
    'AMPS',
    'AMXL-AMZL-BPO',
    'AMZL-FixedCosts-AU',
    'AMZL-SP-and-E',
    'AMZL-UAE',
    'AMZL',
    'Annapurna-Labs-Inc',
    'AVP1-Goods',
    'Baby-Registry-Consumables',
    'Building-Base-Maintenance-Contracts',
    'BPO-IntlStores',
    'BPO-Last-Mile',
    'BPO-Other-Biz',
    'Canteen-Expense',
    'DET3-Sort',
    'Digital-Music',
    'EF-Launches',
    'EG-QC',
    'EU-ATS-SC-FC',
    'EU-E2E-EquipmentRental',
    'EU-E2E-EquipmentRental-SCs',
    'EU-E2E-Medical',
    'EU-TAP-OPM',
    'EVCP-O-and-M',
    'FACT-NonMarketing',
    'FC-Support',
    'FOAA',
    'FC-EGY',
    'FC-KSA',
    'FC-UAE',
    'FP-A',
    'FR-Accounting',
    'GCA-Finance',
    'GCF-BPO',
    'Gift-Cards-EU',
    'GO',
    'GPCS-BPO',
    'GPOC',
    'GroceryTech',
    'GSF-Other',
    'GSF-TBC',
    'Hardware-Dev-Eng',
    'IE-stat',
    'Immigration-NonMarketing',
    'IN-ASSLP-Security',
    'IndiaStore-NonMarketing',
    'Indirect-Procurement',
    'IN-AFO',
    'INOPS-TAAS-VP-Services',
    'IT-EF',
    'ITES-Accounting',
    'IPAT-BPO',
    'Janitorial-CF-ASP',
    'JPPV-Marketing-Cost',
    'Kitchen',
    'Linehaul',
    'Middle-Mile-BPO',
    'MCF-fixed',
    'MCF-fulfilment',
    'MCF-GTM',
    'Manufacturing-and-Logistics-Finance',
    'NA-AFS',
    'NA-Stores-US-Hardline',
    'NAStores-BPO',
    'NACF',
    'NASC-Janitorial-Services',
    'NASC-SouthSecurity-NonMarketing',
    'OAS_VM',
    'Other-Fixed-Costs',
    'OS-SP-Supporting',
    'Pest-Control',
    'PIT-rental',
    'PrivateBrands',
    'PV-IN-Marketing',
    'PV-SVOD-TVOD-Channels-SEAMENA',
    'PV-TVOD-LATCANZ',
    'Ring',
    'RME-Hotline-support',
    'SA-Fresh',
    'SA-QC',
    'Santos',
    'SCs-EGY',
    'SCs-KSA',
    'SCs-UAE',
    'SCs',
    'Security',
    'Security-CF-ASP',
    'Shuttle-Expenses',
    'SPS-BwP-BPO',
    'Statutory-reporting-AT-CZ-DE-SK',
    'Style',
    'Tech-Finance-BPO',
    'SPOC-Receipts',
    'TR-Associates',
    'TS-Invoicing',
    'TwitchLeaseOutsourcing',
    'UK-EF',
    'Vending-Expense',
    'WFM',
    'WW-Flex-Finance',
    'WWCS-BPO',
    'WWGS-BPO',
    'WWGS-International',
    'WWGS-Marketing',
    'WWRR-Bottom-of-the-Funnel-Liquidations'
];

export const XCM_TEAM = 'XCM';
